import { makeRescheduleEligibilityRepository } from 'shared/infra/repositories';

import CheckRescheduleEligibilityUseCase from './implementations/CheckRescheduleEligibilityUseCase';

let instance: CheckRescheduleEligibilityUseCase | null = null;

export default function makeCheckRescheduleEligibilityUseCase() {
  if (!instance) {
    const rescheduleEligibilityRepository =
      makeRescheduleEligibilityRepository();

    instance = new CheckRescheduleEligibilityUseCase(
      rescheduleEligibilityRepository,
    );
  }

  return instance;
}
